import React, { useState, useCallback, useRef, useEffect } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import styles from '../../Css/CustomSettings.module.css'


export default function ProcessedImageCrop(props) {
    const [upImg, setUpImg] = useState(props.image);
    const imgRef = useRef(null);
    const previewCanvasRef = useRef(null);
    const [crop, setCrop] = useState({ unit: "%", width: 30, aspect: null });
    const [completedCrop, setCompletedCrop] = useState(null);
    const [refBlob, setRefBlob] = useState(null);
    const [dimensions, setDimensions] = useState([0, 0, 0, 0]);
    const [cropperList, setCropperList] = useState([[props.image, dimensions]]);
    const [currentPage, setCurrentPage] = useState("")
    const [aspectRatios, setaspectRatios] = useState([
        { aspect: 16 / 9, label: 'cars' ,img:"https://storage.googleapis.com/spyne-website/static/app-dashboard/16-9%20icon.png",text:'16/9'},
        { aspect: 4 / 3, label: 'cars' ,img:"https://storage.googleapis.com/spyne-website/static/app-dashboard/4-3%20icon.png",text:'4/3'},
        { aspect: 1 / 1, label: 'cars' ,img:"https://storage.googleapis.com/spyne-website/static/app-dashboard/1-1%20icon.png",text:'1/1'},
        { aspect: 9 / 16, label: 'fashion' ,img:"https://storage.googleapis.com/spyne-website/static/app-dashboard/16-9%20icon.png",text:'9/16'},
        { aspect: 3 / 4, label: 'fashion' ,img:"https://storage.googleapis.com/spyne-website/static/app-dashboard/4-3%20icon.png",text:'3/4'},
        { aspect: 16 / 9, label: 'product',img:"https://storage.googleapis.com/spyne-website/static/app-dashboard/16-9%20icon.png" ,text:'16/9'},
        { aspect: 4 / 3, label: 'product' ,img:"https://storage.googleapis.com/spyne-website/static/app-dashboard/4-3%20icon.png",text:'4/3'},
        { aspect: 1 / 1, label: 'product' ,img:"https://storage.googleapis.com/spyne-website/static/app-dashboard/1-1%20icon.png",text:'1/1'},
        { aspect: 16 / 9, label: 'footwear',img:"https://storage.googleapis.com/spyne-website/static/app-dashboard/16-9%20icon.png" ,text:'16/9'},
        { aspect: 4 / 3, label: 'footwear' ,img:"https://storage.googleapis.com/spyne-website/static/app-dashboard/4-3%20icon.png",text:'4/3'},
        { aspect: 1 / 1, label: 'footwear' ,img:"https://storage.googleapis.com/spyne-website/static/app-dashboard/1-1%20icon.png",text:'1/1'},
    ])
    const [isFashion, setIsFashion] = useState(false);


    const onLoad = useCallback((img) => {
        imgRef.current = img;
    }, []);

    useEffect(async () => {
        if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
            return;
        }

        if (/fashion/.test(window.location.href)){
            setIsFashion(true)
        }

        const image = imgRef.current;
        const canvas = previewCanvasRef.current;
        const crop = completedCrop;

        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext("2d");
        const pixelRatio = window.devicePixelRatio;

        canvas.width = crop.width * pixelRatio * scaleX;
        canvas.height = crop.height * pixelRatio * scaleY;

        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = "high";
        let setSqueeesePercent = ((360 - image.height) / image.height) + 1
        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

        await setDimensions([crop.x, crop.y, crop.width, crop.height])
        if (!crop || !canvas) {
            return;
        }

        canvas.toBlob((blob) => {
            setRefBlob(blob);
        }, "image/png");
    }, [completedCrop]);

    useEffect(() => {
        const pageUrl = window.location.pathname
        if (pageUrl.match('fashion')) setCurrentPage('fashion')
        if (pageUrl.match('cars')) setCurrentPage('cars')
        if (pageUrl.match('product')) setCurrentPage('product')
        if (pageUrl.match('footwear')) setCurrentPage('fashion')

    })

    const cropRatio = (e) => {
        setCrop({ unit: "%", width: 30, aspect: e });
    };

    const cropper = (bool) => {
        if (bool) {

            setCrop({
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                aspect: completedCrop.aspect
            })
            handleCroppedImage(refBlob, dimensions)

        }
        else if (!bool && cropperList.length != 1) {
            setCrop(
                {
                    x: (cropperList[0][1])[0] - (cropperList[1][1])[0],
                    y: (cropperList[0][1])[1] - (cropperList[1][1])[1],
                    width: 640 - (cropperList[0][1])[0] - (cropperList[0][1])[2],
                    height: 360 - (cropperList[0][1])[3] - (cropperList[0][1])[1],
                    aspect: crop.aspect
                }
            )
            handleCroppedImage(null, null)
        }
    }

    const handleCroppedImage = (imageBlob, dimension) => {

        if (imageBlob != null) {
            let x = Math.floor(dimension[0] + (cropperList[0][1])[0])
            let y = Math.floor(dimension[1] + (cropperList[0][1])[1])
            let width = Math.floor(640 - dimension[2] - dimension[0])
            let height = Math.floor(360 - dimension[3] - dimension[1])
          

            cropperList.unshift([imageBlob, [x, y, width, height]])
            setCropperList(cropperList)
        }
        else {
            cropperList.shift()
            setCropperList(cropperList)
        }
        if (cropperList.length >= 2) {
            setUpImg(URL.createObjectURL(cropperList[0][0]))
        }
        else if (cropperList.length == 1) {
            setUpImg(cropperList[0][0])
        }
        props.handleCroppedImage(cropperList[0])
    }

    return (
        <div >
            <div className={[styles['react-crop-container']]} >
                <ReactCrop
                    src={upImg}
                    crossorigin="anonymous"
                    ruleOfThirds
                    onImageLoaded={onLoad}
                    crop={crop}
                    onChange={(c) => setCrop(c)}
                    onComplete={(c) => setCompletedCrop(c)}
                />
            </div>
            <div className={[styles['crop-options-container']]}>
                <div className={[styles['crop-options']]}>
                    <button className={crop.aspect === null ? [styles['crop-active'], ''].join(' ') : [styles[''], ''].join(' ')} onClick={() => cropRatio(null)}><img src="https://storage.googleapis.com/spyne-website/static/app-dashboard/Freeform%20icon.png" /><br /><div className={styles['crop-options-text']}>Freeform</div></button>
                    {aspectRatios.map((button, i) => {
                        return (
                            button.label === currentPage ?
                                <button className={crop.aspect === button.aspect ? [styles['crop-active'], ''].join(' ') : [styles[''], ''].join(' ')} onClick={() => cropRatio(button.aspect)}><img src={button.img} /><br /><div className={styles['crop-options-text']}>{button.text}</div></button>
                                :
                                null
                        )
                    })}

                </div>
                <div className={[styles['crop-button']].join(' ')}>
                    <button className={styles['crop-button-undo']} onClick={() => cropper(false)}>undo</button>
                    <button className={styles['crop-button-crop']} onClick={() => cropper(true)}>crop</button>
                </div>

            </div>
            <div>
                <canvas
                    ref={previewCanvasRef}
                    // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
                    style={{
                        width: Math.round(completedCrop?.width ?? 0),
                        height: Math.round(completedCrop?.height ?? 0),
                        display: "none"
                    }}
                />
            </div>
        </div>
    );
}
